import React, {PureComponent} from "react";
import conf from "../../../fr/conf.js";
import PropTypes from "prop-types";

export default class TwineedsLinkedinLink extends PureComponent {
  static propTypes = {
    text: PropTypes.string.isRequired,
  };
  render() {
    return <a href={conf.site.linkedinUrl} target="_blank" rel="noopener noreferrer">{this.props.text}</a>
  }
}